export const getTagTypeLabel = (type) => {
  const map = {
    zinkerzCamp: 'Zinkerz Camp',
    accomodations: 'Accommodations',
    paidReferrer: 'Paid Referrer',
    clientReferral: 'Client Referral'

  }

  return map[type] || type
}
